<template>
    <div>
        <div class="sidebar-top">
            <div class="search_row">
                <img src="./../assets/channels/lupa.png"
                 class="icon_img">
                <!-- <input
                    type="text"
                    class="search_input"
                    placeholder="Ingresa un distrito, avenida o punto de referencia"> -->
                 <vue-simple-suggest
                    v-model="input"
                    :list="pos"
                    display-attribute="code"
                    value-attribute="code"
                    :filter-by-query="true"
                    :max-suggestions="5"
                    @suggestion-click="onSuggestClick"
                    @select="onSuggestClick"
                    placeholder="Ingresa un distrito, avenida o punto de referencia"
                    :controls="{
                        selectionUp: [38],
                        selectionDown: [40],
                        select: [13]
                    }"
                    >
                </vue-simple-suggest>
            </div>
            <div style="opacity: 0.54;border: solid 1px #c7cdd4;"></div>
            <div class="search_row">
                <div class="fl_left" @click="changeStatus('Todos')">
                    <img :src="urlTodosIcon" class="icon_img">
                    <span class="span_css" :class="isTodos ? 'spanActive': ''">Todos</span>
                </div>
                <div class="fl_left pl-10" @click="changeStatus('Recharge')">
                    <img :src="urlRechargeIcon" class="icon_img">
                    <span class="span_css" :class="isRecharge ? 'spanActive': ''">Recargas</span>
                </div>
                <div class="fl_left pl-10" @click="changeStatus('RechargeReceipts')">
                    <img :src="urlRechargeReceiptsIcon" class="icon_img">
                    <span class="span_css" :class="isRechargeReceipts ? 'spanActive': ''">Recargas y Recibos</span>
                </div>
                <div class="fl_left pl-10" @click="changeStatus('CenterOfAttention')">
                    <img :src="urlCenterOfAttentionIcon" class="icon_img">
                    <span class="span_css" :class="isCenterOfAttention ? 'spanActive': ''">C. de atención</span>
                </div>
            </div>
        </div>
        <div class="btn_mobile" :class="isShowSidebar ? 'show': 'hidden'" @click="showMobileSidebar()">
            <img src="./../assets/channels/back.png" style="opacity: 1; transform: rotate(180deg);"
                class="icon_img">
        </div>
        <div class="sidebar-bottom" :class="isShowSidebar ? 'hidden': 'show'">
            <div class="result_title">
                <img src="./../assets/channels/back.png" :class="showIconBack ? 'show': 'hidden'"
                 class="icon_img" style="margin-left: 20px"  @click="showMobileSidebar()">
                <span>Resultado de Búsqueda</span>
            </div>
            <div class="search_results">
                <div class="result_detail" :key="index" v-for="(m, index) in pos" @click="detailPos(m)">
                    <div class="result_detail_left">
                        <div class="detail_title">{{ m.code }}</div>
                        <div class="detail_hours">{{ m.workTime }}</div>
                    </div>
                    <div class="result_detail_right">
                        <a 
                            :href="'https://www.google.com/maps/dir/'+center.lat+','+center.lng+'/'+m.position.lat+','+m.position.lng"
                            style="text-decoration: none;"
                            target="_blank">
                            <img src="./../assets/channels/combined-shape.png">
                            <div class="title_right">Cómo llegar</div>
                        </a>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <div class="sidebar-right">
          <a
              href="https://bitel.com.pe/puntos-de-pago"
              style="text-decoration: none;"
              target="_blank">
              <img src="./../assets/channels/bancos.png" style="height: 40px;">
          </a>
        </div>
    </div>
</template>

<script>
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS
    import { EventBus } from '../config/EventBus'

    export default {
        name: "Sidebar",
        props: ['pos'],
        components: {
            VueSimpleSuggest
        },
        data() {
          return {
            center: { lat: -12.097038, lng: -77.01598 },
            newHeight: 145,
            item: {},
            items: JSON.parse(JSON.stringify(this.pos)),
            suggestItem: {},
            input: '',
            selected: null,
            isTodos: false,
            isRecharge: false,
            isRechargeReceipts: false,
            isCenterOfAttention: false,
            urlTodosIcon: require('@/assets/channels/shape.png'),
            urlRechargeIcon: require('@/assets/channels/marker.png'),
            urlRechargeReceiptsIcon: require('@/assets/channels/marker.png'),
            urlCenterOfAttentionIcon: require('@/assets/channels/marker.png'),
            isShowSidebar: true,
            showIconBack: true,
          };
        },
        mounted() {
            this.detectScreen();
        },
        methods: {
           detailPos(marker) {
            EventBus.$emit('posDetail', marker);
           },
            onSuggestClick (suggest) {
                this.selected = suggest
                this.detailPos(suggest)
            },
            changeStatus (type) {
                switch(type) {
                    case 'Todos':
                        if(this.isTodos) {
                            this.isTodos = false;
                            this.urlTodosIcon = require('@/assets/channels/shape.png');
                            this.isRecharge = false;
                            this.urlRechargeIcon = require('@/assets/channels/marker.png');
                            this.isRechargeReceipts = false;
                            this.urlRechargeReceiptsIcon = require('@/assets/channels/marker.png');
                            this.isCenterOfAttention = false;
                            this.urlCenterOfAttentionIcon = require('@/assets/channels/marker.png');
                        } else {
                            this.isTodos = true;
                            this.urlTodosIcon = require('@/assets/channels/shape_1.png');
                            this.isRecharge = true;
                            this.urlRechargeIcon = require('@/assets/channels/marker_1.png');
                            this.isRechargeReceipts = true;
                            this.urlRechargeReceiptsIcon = require('@/assets/channels/marker_2.png');
                            this.isCenterOfAttention = true;
                            this.urlCenterOfAttentionIcon = require('@/assets/channels/marker_3.png');
                        }
                        break;
                    case 'Recharge':
                        if(this.isRecharge) {
                            this.isRecharge = false;
                            this.urlRechargeIcon = require('@/assets/channels/marker.png');
                        } else {
                            this.isRecharge = true;
                            this.urlRechargeIcon = require('@/assets/channels/marker_1.png');
                        }
                        break;
                    case 'RechargeReceipts':
                        if(this.isRechargeReceipts) {
                            this.isRechargeReceipts = false;
                            this.urlRechargeReceiptsIcon = require('@/assets/channels/marker.png');
                        } else {
                            this.isRechargeReceipts = true;
                            this.urlRechargeReceiptsIcon = require('@/assets/channels/marker_2.png');
                        }
                        break;
                    case 'CenterOfAttention':
                        if(this.isCenterOfAttention) {
                            this.isCenterOfAttention = false;
                            this.urlCenterOfAttentionIcon = require('@/assets/channels/marker.png');
                        } else {
                            this.isCenterOfAttention = true;
                            this.urlCenterOfAttentionIcon = require('@/assets/channels/marker_3.png');
                        }
                        break;
                }
                if(this.isRecharge && this.isRechargeReceipts && this.isCenterOfAttention) {
                    this.isTodos = true;
                    this.urlTodosIcon = require('@/assets/channels/shape_1.png');
                } else {
                    this.isTodos = false;
                    this.urlTodosIcon = require('@/assets/channels/shape.png');
                }
            },
            detectScreen() {
                if (window.innerWidth > 1024) {
                    this.isShowSidebar = false
                    this.showIconBack = false
                } else {
                    this.isShowSidebar = true
                    this.showIconBack = true
                }
            },
            showMobileSidebar() {
                if (this.isShowSidebar) {
                    this.isShowSidebar = false
                } else {
                    this.isShowSidebar = true
                }
            }
        }
    }
</script>

<style>
     .search_row {
        height: 38px; 
        padding-left: 14px; 
        padding-top: 24px;
    }
    .search_row > div {
        outline: none;
    }
    .suggest_row {
        padding-left: 14px;
        padding-top: 7.5px;
        padding-bottom: 7.5px;
        outline: none;
    }
    .suggest_row:hover {
        background-color: rgba(216, 216, 216, 0.15);
        color: #ffffff;
    }
    .icon_img {
        float: left;
        object-fit:contain;
        opacity:0.55;
    }
    .search_input, .vue-simple-suggest.designed .input-wrapper input {
        width: calc(420px - 46px);
        padding-left: 10px;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        margin-right: 10px;
        outline: none;
        border: none;
        color: #304053;
        font: 14px/16px "Roboto", sans-serif;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
    }
    .span_css{
        font: 14px/16px "Roboto", sans-serif;
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #a5b2c1;
    }
    .fl_left {
        float:left;
    }
    .pl-10 {
        padding-left: 10px;
    }
    .result_title span {
        font: 14px/16px "Roboto", sans-serif;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #333333;
        padding-left: 10px;
        padding-top: 4px;
    }
    .result_detail {
        width: 362px;
        border-radius: 8px;
        background-color: rgba(216, 216, 216, 0.15);
        margin-top: 10px;
        padding-top: 14px;
        padding-left: 19px;
        margin-left: 20px
    }
    .result_detail_left, .result_detail_right {
        padding-bottom: 18px;
    }
    .result_detail_left {
        float: left;
        width: calc(100% - 81px);
    }
    .result_detail_right {
        float:right;
        margin-right: 16px;
        text-align: center;
        padding-top: 2px;
    }
    .clear {
        clear: both;
    }
    .detail_title , .detail_add, .detail_hours {
        font: 14px/16px "Roboto", sans-serif;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #333333;
    }
    .detail_title {
        font-weight: bold;
        outline: none;
    }
    .title_right {
        font: 14px/16px "Roboto", sans-serif;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #4cb9ca;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 7px;
        height: 35px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #e8e8e8; 
        border-radius: 3.5px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #a8a8a8; 
        border-radius: 3.5px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8; 
    }
    .spanActive {
        color: #00a5b1
    }
    .suggest_title {
        width: calc(420px - 44px);
        padding-left: 10px;
        outline: none;
        border: none;
        color: #304053;
        font: 14px/16px "Roboto", sans-serif;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        float:right
    }
    .clear {
        clear: both;
    }
    .vue-simple-suggest.designed .input-wrapper input{
        width: calc(420px - 56px);
        float:right;
        padding-top: 2px;
        padding-left: 0;
    }
     .vue-simple-suggest.designed.focus .input-wrapper input {
        border: none;
     }
     .vue-simple-suggest.designed .suggestions {
        top: calc(100% + 35px);
     }
    .sidebar-top {
        position: absolute; 
        top: 10px; 
        left: 10px; 
        width: 420px; 
        z-index: 9999; 
        height: 125px; 
        border-radius: 10px; 
        box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.32); 
        background-color: #ffffff;
    }
    .sidebar-bottom {
        top:145px; 
        height: calc(100vh - 160px);
        position: absolute; 
        left: 10px; 
        width: 420px; 
        z-index: 5000; 
        overflow-y: scroll; 
        padding-top: 14px; 
        border-radius: 6px; 
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05); 
        background-color: #ffffff;
    }
    .sidebar-right {
        position: absolute;
        top: 10px;
        right: 60px;
        z-index: 9999;
    }
    .hidden { display: none }
    @media screen and (max-width:1024px){
        .hidden-mobile, .hidden { display: none }
        .show { display: block }
        .sidebar-top {
            top: 0;
            left: 0;
            width: 100%;
            height: 125px;
            border-radius: 0; 
        }
        .sidebar-right {
          position: absolute;
          top: 135px;
          right: 10px;
          z-index: 1000;
        }
        .vue-simple-suggest.designed .input-wrapper input {
            width: calc(100% - 56px);
        }
        .search_row .span_css {
            font-size: 12px;
            padding-left: 2px;
        }
        .sidebar-bottom {
            width: calc(100% - 20px);
        }
        .result_detail {
            width: 332px;
        }
        .btn_mobile {
            position: absolute;
            top: 130px;
            z-index: 5000;
            left: 10px;
        }
    }
</style>